import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import CallToActionSection from "./commonComponent/CallToActionSection";
import { Link } from "react-router-dom";
import "./common.css";
import { domainUrl } from "app/Api/axios";
import { useLocation } from "react-router-dom";
import blogData from './blog.json';

const Blogs = () => {
  const location = useLocation();

  const [currentPage, setCurrentPage] = useState(1);
  const [blogTitles, setblogTitles] = useState([]);

  useEffect(() => {
    setblogTitles(blogData);
  }, []);

  // Handle page change
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


const structuredData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Time Tango - Efficient Employee Attendance & Activity Tracking System",
  "image": "https://timetango.in/assets/img/hero/Hero_Combine.png",
  "description": "The all-in-one platform for effortless leave management, insightful activity tracking, and smooth attendance management.",
  "brand": {
    "@type": "Brand",
    "name": "Time Tango",
    "logo": "https://timetango.in/assets/logo3.svg",
    "sameAs": [
      "https://www.facebook.com/people/TimeTango/61550584126267/",
      "https://www.linkedin.com/showcase/99884387/",
      "https://www.instagram.com/timetango.in/"
    ]
  },
  "offers": {
    "@type": "Offer",
    "url": "https://timetango.in",
    "priceCurrency": "INR",
    "price": "30",
    "availability": "https://schema.org/InStock"
  }
};




  const blogsPerPage = 9;
  const totalBlogs = blogTitles.length;
  const totalPages = Math.ceil(totalBlogs / blogsPerPage);

  // Get the blogs for the current page
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = blogTitles.slice(indexOfFirstBlog, indexOfLastBlog);


  const canonicalURL = `${domainUrl}${location.pathname}`;

  return (
    <>
      <Helmet>
        <title>
          Time Tango - Efficient Employee Attendance & Activity Tracking System.
        </title>
        <meta
          name="description"
          content="Track employee attendance with Time Tango’s efficient and user-friendly time tracking & activity tracking software. Simplify HR management today with additional feature as Leave management system."
        />
        <meta
          property="og:title"
          content="Time Tango - Efficient Employee Attendance & Activity Tracking System"
        />
        <meta
          property="og:description"
          content="Track employee attendance with Time Tango’s efficient and user-friendly time tracking & activity tracking software. Simplify HR management today with additional feature as Leave management system."
        />
        <meta
          property="og:image"
          content="https://timetango.in/assets/logo3.svg"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalURL} />
        <link rel="canonical" href={canonicalURL} />
        <meta property="og:site_name" content="Timetango" />
        <meta name="language" content="english" />
        <meta name="robots" content="index, follow" />
        <meta
          name="google-site-verification"
          content="HeqJ8arMIZIDpCmRH1zlrNu601VS7Wp92JoTy_9bARM"
        ></meta>
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      <section className="section-padding bg-white mt-5 mt-lg-0">
        <div className="container">
          <div className="d-flex flex-column gap-4 align-items-center mt-4 paddingx">
            <div>
              <h1 className="text-center">Blog</h1>
            </div>
            <div
              className="d-flex gap-4 justify-content-center flex-wrap w-100 "
              style={{ rowGap: "16px" }}
            >
              {currentBlogs?.map((item, index) => (
                <div key={index} className="card d-flex flex-column">
                  <div>
                    <Link to={item.link}>
                      <img
                        src={item.img}
                        alt={item.alt}
                        className="w-100 h-100"
                      />
                    </Link>
                  </div>
                  <div className="px-4">
                    <Link to={item.link}>
                      <p className="fs-16">{item.title}</p>
                      <div className="py-2">
                        <button className="btn btn-link p-0">
                          Continue reading <span>&rarr;</span>
                        </button>
                      </div>
                    </Link>
                  </div>
                </div>
              ))}
            </div>

            {/* Pagination Controls */}
            <div className="d-flex justify-content-center gap-3">
              <button
                onClick={() => paginate(currentPage - 1)}
                disabled={currentPage === 1}
                className="btn btn-primary pagination-btn"
              >
                Previous
              </button>
              <span>
                Page {currentPage} of {totalPages}
              </span>
              <button
                onClick={() => paginate(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="btn btn-primary pagination-btn"
              >
                Next
              </button>
            </div>

          </div>
        </div>
      </section>
      {/* componnent 2 */}
      <CallToActionSection></CallToActionSection>
    </>
  );
};

export default Blogs;
